import * as helpers from './helpers'
import { saveProgress } from '@brainstud/react-tbl/features/account/store'

/* -------------------------------------------------- */

export const loadProgressSuccess = payload => {
  return { type: 'QUIZ_LOAD_PROGRESS_SUCCESS', payload }
}

export const loadProgress = data => {
  return (dispatch, getState) => {
    dispatch(loadProgressSuccess(data))
  }
}

/* -------------------------------------------------- */

export const setProgressSuccess = payload => {
  return { type: 'QUIZ_SET_PROGRESS_SUCCESS', payload }
}

export const setProgress = (anyId, progress) => {
  return (dispatch, getState) => {
    dispatch(setProgressSuccess({ id: anyId, progress }))
    dispatch(saveProgress())
  }
}

/* -------------------------------------------------- */

export const updateProgressSuccess = payload => {
  return { type: 'QUIZ_UPDATE_PROGRESS_SUCCESS', payload }
}

export const updateProgress = quizId => {
  return (dispatch, getState) => {
    const { quizes } = getState()

    const quiz = quizes.quizes.byId[quizId]
    const quizProgress = quizes.progress[quizId] || {}

    let viewed = 0
    let touched = 0
    let submited = 0
    let points = 0

    quiz.questions.forEach(q => {
      const progress = quizes.progress[q] || {}

      if(progress.points) points+=progress.points
      if(progress.viewed) viewed++
      if(progress.touched) touched++
      if(progress.submited) submited++
    })

    const progress = {
      passed: points >= quiz.scoreToPass,
      currentScore: points,
      remainingToView: quizProgress.totalQuestions - viewed,
      remainingToTouch: quizProgress.totalQuestions - touched,
      remainingToSubmit: quizProgress.totalQuestions - submited,
    }

    dispatch(updateProgressSuccess({ id: quizId, progress }))
    dispatch(saveProgress())
  }
}

/* -------------------------------------------------- */

export const viewQuestion = qId => {
  return (dispatch, getState) => {
    const { quizes } = getState()
    const question = quizes.questions.byId[qId]

    dispatch(setProgress(question.quizId, {
      location: 'question',
      question: qId,
    }))

    dispatch(setProgress(qId, {
      viewed: true,
    }))

    dispatch(updateProgress(question.quizId))
  }
}

export const touchQuestion = (qId, data) => {
  return (dispatch, getState) => {
    const { quizes } = getState()
    const question = quizes.questions.byId[qId]

    dispatch(setProgress(qId, {
      ...data,
      touched: true,
    }))

    dispatch(updateProgress(question.quizId))
  }
}

export const submitQuestion = qId => {
  return (dispatch, getState) => {
    const { quizes } = getState()

    const question = quizes.questions.byId[qId]
    const answersAll = quizes.answers.byId
    const progressAll = quizes.progress
    const progress = progressAll[question.id] || {}

    const real = helpers.getCorrectAnswers(question.answers, answersAll)
    const picked = [].concat(progress.answer)
    const status = helpers.compareAnswers(question.type, real, picked)
    const points = helpers.getPoints(question.type, status, question.points)

    dispatch(setProgressSuccess({
      id: question.id,
      progress: {
        submited: true,
        passed: points >= question.points,
        points: points,
      }
    }))

    dispatch(updateProgress(question.quizId))
  }
}

/* -------------------------------------------------- */

export const submitQuestions = quizId => {
  return (dispatch, getState) => {
    const { quizes } = getState()

    const questions = quizes.questions.byId
    const quiz = quizes.quizes.byId[quizId]

    quiz.questions.forEach(q => dispatch(submitQuestion(questions[q].id)))

    dispatch(setProgress(quizId, {
      completed: true,
    }))
  }
}

/* -------------------------------------------------- */
